import { Radio } from '~/components/Form';

import type { InputFieldProps as Props } from './types';

/** Renders one option of a wizard question. Must sit inside the `Radio.Group` that `Fieldset` renders. */
export const InputFieldRadio = ({ children, value }: Props) => {
  return (
    <Radio.Root value={value}>
      <Radio.Label>{children}</Radio.Label>
    </Radio.Root>
  );
};
